// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlbumTrackAddController from "./album_track_add_controller"
application.register("album-track-add", AlbumTrackAddController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AudioSignaturesController from "./audio_signatures_controller"
application.register("audio-signatures", AudioSignaturesController)

import BestQualitySelectorController from "./best_quality_selector_controller"
application.register("best-quality-selector", BestQualitySelectorController)

import CheckboxSetClearAllController from "./checkbox_set_clear_all_controller"
application.register("checkbox-set-clear-all", CheckboxSetClearAllController)

import CheckboxSetClearClassController from "./checkbox_set_clear_class_controller"
application.register("checkbox-set-clear-class", CheckboxSetClearClassController)

import CheckboxSubmitterController from "./checkbox_submitter_controller"
application.register("checkbox-submitter", CheckboxSubmitterController)

import CheckboxUpdaterController from "./checkbox_updater_controller"
application.register("checkbox-updater", CheckboxUpdaterController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColumnCheckboxController from "./column_checkbox_controller"
application.register("column-checkbox", ColumnCheckboxController)

import ConditionalRequiredController from "./conditional_required_controller"
application.register("conditional-required", ConditionalRequiredController)

import DetailToggleController from "./detail_toggle_controller"
application.register("detail-toggle", DetailToggleController)

import DynamicFormsController from "./dynamic_forms_controller"
application.register("dynamic-forms", DynamicFormsController)

import FaceboxController from "./facebox_controller"
application.register("facebox", FaceboxController)

import FieldUpdaterController from "./field_updater_controller"
application.register("field-updater", FieldUpdaterController)

import FolderToggleController from "./folder_toggle_controller"
application.register("folder-toggle", FolderToggleController)

import FormFillerController from "./form_filler_controller"
application.register("form-filler", FormFillerController)

import FormTrackSortableController from "./form_track_sortable_controller"
application.register("form-track-sortable", FormTrackSortableController)

import SidebarStateController from "./sidebar_state_controller"
application.register("sidebar-state", SidebarStateController)

import HiddenFieldsController from "./hidden_fields_controller"
application.register("hidden-fields", HiddenFieldsController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LastfmArtistReviewController from "./lastfm_artist_review_controller"
application.register("lastfm-artist-review", LastfmArtistReviewController)

import MasterRecordingNotesController from "./master_recording_notes_controller"
application.register("master-recording-notes", MasterRecordingNotesController)

import MultiselectController from "./multiselect_controller"
application.register("multiselect", MultiselectController)

import PlayerController from "./player_controller"
application.register("player", PlayerController)

import Playlist__SelectorController from "./playlist/selector_controller"
application.register("playlist--selector", Playlist__SelectorController)

import Project__SelectorController from "./project/selector_controller"
application.register("project--selector", Project__SelectorController)

import Search__FillFormController from "./search/fill_form_controller"
application.register("search--fill-form", Search__FillFormController)

import SelectUpdaterController from "./select_updater_controller"
application.register("select-updater", SelectUpdaterController)

import TableRowSortableController from "./table_row_sortable_controller"
application.register("table-row-sortable", TableRowSortableController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import TagSearchController from "./tag_search_controller"
application.register("tag-search", TagSearchController)

import ToastMeController from "./toast_me_controller"
application.register("toast-me", ToastMeController)
